import { useMemo } from "react";
import { Box, IconButton } from "@mui/material";
import { TooltipIcon } from "src/Icons";
import { CustomTooltip } from "src/styledComponents";

import { CustomAdminCellProps } from "./CustomAdminCell.types";

export function CustomAdminCell ({ adminsArray }: CustomAdminCellProps) {
  const arr = adminsArray?.filter((el: any) => el.status === 'active');

  const adminsStr = useMemo(() => {
    return arr?.length > 1 ? (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: '100%',
        }}
      >
        <span>{`${arr.length} ${'admins'}`}</span>
        <CustomTooltip
          title={
            <Box
              display="flex"
              flexDirection="row"
              sx={{
                flexWrap: 'wrap',
              }}
            >
              {arr?.map(({ firstName, lastName }, i: number) => (
                <Box
                  key={i}
                  sx={{
                    textWrap: 'nowrap',
                    marginRight: '4px',
                  }}
                >
                  {`${`${firstName  } ${  lastName}`}${
                    i === arr.length - 1 ? '.' : ';'
                  }`}
                </Box>
              ))}
            </Box>
          }
          placement="bottom-end"
        >
          <IconButton
            className="tooltip-button"
            sx={{
              padding: 0,
              color: '#4F4F4F',
              fontSize: '16px',
              '&:hover': {
                color: '#BF295C',
                backgroundColor: 'transparent',
              },
            }}
          >
            <TooltipIcon fontSize="inherit" />
          </IconButton>
        </CustomTooltip>
      </Box>
    ) : arr.length === 1 ? (
      arr
        .map(({ firstName, lastName }) => `${firstName  } ${  lastName}`)
        .toString()
    ) : (
      'Not selected'
    );
  }, [arr]);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="row"
      sx={{
        width: '100%',
      }}
    >
      {adminsStr}
    </Box>
  )
}
